var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgEsCt = function SvgEsCt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fcdd09",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 90h810m0 120H0m0 120h810m0 120H0",
    stroke: "#da121a",
    strokeWidth: 60,
    transform: "matrix(.79012 0 0 .88889 0 0)"
  })));
};
export default __webpack_public_path__ + "assets/b1f766f9322f3372a229e6bb3af1c3bb.svg";
export { SvgEsCt as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/es-ct.svg